import * as React from "react";
import { Typography, Container, Box } from "@material-ui/core";
import { RouteComponentProps } from "react-router";
import { LotFormComponent } from "../components/create-lot/LotFormComponent";
import { SecureArea } from "../components/authentication/SecureArea";
import { MemberPermission } from "../services/MemberService";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../services/TelemetryService";

type UpdateLotParams = { id: string; auctionId: string | undefined };

function UpdateLot({ match }: RouteComponentProps<UpdateLotParams>) {
  return (
    <Container maxWidth={"lg"} fixed>
      <SecureArea memberPermission={MemberPermission.BucketAdmin}>
        <Typography variant="h4" color="primary" gutterBottom>
          Update Lot
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          Fill out the form to update the existing lot.
        </Typography>
        <Box mt={4}>
          <LotFormComponent id={match.params.id} auctionId={match.params.auctionId === undefined ? null : match.params.auctionId} />
        </Box>
      </SecureArea>
    </Container>
  );
}

export default withAITracking(reactPlugin, UpdateLot, "UpdateLot");
